<template>
    <div>
        
        <BoneCrafts />
    </div>
</template>

<script>

import BoneCrafts from '../blog-details/BoneCrafts.vue'

export default {
    components: {
       
        BoneCrafts,
    }
}
</script>